import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { MatSnackBar } from '@angular/material/snack-bar';
import { App, FieldIdentifier, MapSiteDataPreview, Project } from '../../models';
import { SiteFieldsNumericIds } from '../../shared/enums';
import { MapDataService } from '../data-services';
import { MapSiteDataPreviewLogicServiceModel } from './models';

@Injectable({
    providedIn: 'root'
})

export class MapSiteDataPreviewLogicService {
    private _mapSiteDataReady = new Subject<boolean>();
    mapSiteDataReady$ = this._mapSiteDataReady.asObservable();

    model: MapSiteDataPreviewLogicServiceModel;

    constructor(
        private _mapDataService: MapDataService,
        private _snackBar: MatSnackBar
    ) { }

    getMapSiteDataPreviewForProject(app: App, project: Project): void {
        const mapSiteDataPreviewRequest$ = project.isSummaryProject === true
            ? this._mapDataService.getSummaryProjectMapSiteDataPreview(app, project)
            : this._mapDataService.getMapSiteDataPreviewByProjectId(app, project);
        mapSiteDataPreviewRequest$
            .subscribe({
                next: (mapSiteDataPreview: MapSiteDataPreview) => {
                    if (mapSiteDataPreview === null) {
                        this.setDefaultMapSiteDataPreview();
                    }
                    else {
                        this.setCurrentMapSiteDataPreview(mapSiteDataPreview);
                    }
                },
                error: () => {
                    this._snackBar.open(`Error retrieving map ${app.aliases.site.singular.toLocaleLowerCase()} data preview`, 'Close', { duration: 5000 });
                }
            }).add(() => {
                this._mapSiteDataReady.next(true);
            });
    }

    setDefaultMapSiteDataPreview(): void {
        const currentMapSiteDataPreview = new MapSiteDataPreview();
        this.setDefaultSelectedFields(currentMapSiteDataPreview);
        this.setCurrentMapSiteDataPreview(currentMapSiteDataPreview);
    }

    setCurrentMapSiteDataPreview(mapSiteDataPreview: MapSiteDataPreview): void {
        this.model.currentMapSiteDataPreview = mapSiteDataPreview;
    }

    initModel(): void {
        this.model = new MapSiteDataPreviewLogicServiceModel();
    }

    setDefaultSelectedFields(mapSiteDataPreview: MapSiteDataPreview): void {
        const locationField = {
            fieldId: SiteFieldsNumericIds.Coordinates,
            gridColumnId: null,
        } as FieldIdentifier;

        mapSiteDataPreview.selectedFields = [
            locationField
        ];
    }
}
